// extracted by mini-css-extract-plugin
module.exports = {"studentBioAppFormContainer":"styles_studentBioAppFormContainer___fjTc","bioFormHeaderText":"styles_bioFormHeaderText__QEu2o"};